import UtilsService from '@/services/utils.service';

export default class Column {
  name;
  label;
  sortable = false;
  cellRenderer = null;
  valueParser = null;
  options = {};
  constructor(options) {
    Object.assign(this, options);
  }

  getValue(data = {}) {
    let value = this.value ? UtilsService.getDeepValue(data, this.value) : null;
    if (this.valueParser && typeof this.valueParser === 'function') {
      value = this.valueParser(value, data);
    }
    return value;
  }
}
